import { useDrawFeature, useDrawingContext } from '@ais-ui/react-openlayers';

export function useDrawings() {
  const drawingContext = useDrawingContext();

  const { undo, clearDrawing } = useDrawFeature(
    drawingContext.geometryType,
    drawingContext.onDraw.current,
    drawingContext.onDraw.current,
    drawingContext.existingFeature.current,
    drawingContext.setIsValidDrawing,
    drawingContext.drawingStyle,
    drawingContext.maxPoints,
    drawingContext.setRadius,
    drawingContext.validateWhileDrawing
  );

  drawingContext.undo.current = undo;
  drawingContext.clearDrawing.current = clearDrawing;
}
